import styled, { AnyStyledComponent } from "styled-components";
import { NewsletterOptinStyleProps } from "./newsletterOptin.types";
import COLORS from "../../style/universal.color";
import FONTS from "../../style/fonts";
import Button from "../Button/button";
import TextInput from "../TextInput/textInput";
import BREAKPOINTS from "../../style/breakpoints";

const { mlbGrey1, mlbGrey2, mlbGrey6, mlbGrey7 } = COLORS;

export const Form: AnyStyledComponent = styled.form`
  background: ${({ dark }: { dark: boolean }) =>
    `${dark ? mlbGrey7 : mlbGrey1}`};
  border-radius: 6px;
  color: ${({ dark }: NewsletterOptinStyleProps) =>
    dark ? mlbGrey2 : mlbGrey6};
  font-family: ${FONTS.primaryFont};
  font-weight: 500;
  padding: 16px 16px 24px;
`;

export const Fieldset: AnyStyledComponent = styled.fieldset`
  border: 0;
  padding: 0;
  text-align: center;
`;

export const Title: AnyStyledComponent = styled.div`
  font-size: 19px;
  font-weight: 700;
  margin-bottom: 8px;
`;

export const Message: AnyStyledComponent = styled.div`
  line-height: 1.5;
  margin: 0 auto 16px;
  max-width: 470px;
  padding-left: ${({ hasIcon }: { hasIcon: boolean }) =>
    hasIcon ? "24px" : "0"};
  position: relative;
  width: fit-content;

  p {
    margin-top: 0;
  }
`;

export const Input: AnyStyledComponent = styled(TextInput)`
  display: block;
  font-weight: 500;

  input {
    box-sizing: border-box;
    margin-bottom: 16px;
  }

  @media only screen and (min-width: ${BREAKPOINTS.sm}) {
    display: flex;
    flex-grow: 1;
    margin-right: 8px;
  }
`;

export const InputWrapper: AnyStyledComponent = styled.div`
  display: block;

  @media only screen and (min-width: ${BREAKPOINTS.sm}) {
    display: flex;
  }
`;

export const Submit: AnyStyledComponent = styled(Button)`
  margin-left: auto;
  margin-right: auto;
`;
